// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__8DKu6","choiceBoxes":"toolbarselects_choiceBoxes__3YbpA","simpleField":"toolbarselects_simpleField__3Eynv"};